export default __webpack_public_path__ + "static/media/home-shop-classic-05.306f5e82.png";